import {
  login as loginRepository,
  singup as singupRepository,
  logout as logoutRepository,
  getUserSession as getUserSessionRepository,
  verifyEmail as verifyEmailRepository,
  recoverPass as recoverPassRepository,
  verifyEmailPassRecover as verifyEmailPassRecoverRepository,
  changePassword as changePasswordRepository,
  getFirebaseToken as getFirebaseTokenRepository,
  resendVerificationEmail as resendVerificationEmailRepository,
} from "../repositories/AuthRepository";
import { buildLoginContext } from "../utils/loginContext";

export const loginService = async (credentials) => {
  try {
    // /api/sec/login recibe, ademas de email/password, el contexto del acceso
    // (dispositivo, ipAddress, latitude, longitude, userAgent). Se arma aqui y no
    // en la pantalla para que todos los puntos de entrada manden lo mismo; el
    // spread deja que un caller pueda sobrescribir cualquier campo.
    return await loginRepository({ ...(await buildLoginContext()), ...credentials });
  } catch (error) {
    throw error;
  }
}

export const singupService = async (userinfo) => {
  try {
    return await singupRepository(userinfo);
  } catch (error) {
    throw error;
  }
}

export const logoutService = async (credentials) => {
  try {
    return await logoutRepository(credentials);
  } catch (error) {
    throw error;
  }
}

export const getUserSessionService = async (payload) => {
  try {
    return await getUserSessionRepository(payload);
  } catch (error) {
    throw error;
  }
}

export const recoverPassService = async (credentials) => {
  try {
    return recoverPassRepository(credentials);
  } catch (error) {
    throw error;
  }
}

export const verifyEmailService = async (code) => {
  try {
    return await verifyEmailRepository(code);
  } catch (error) {
    throw error;
  }
}

export const verifyEmailPassRecoverService = async (code) => {
  try {
    return await verifyEmailPassRecoverRepository(code);
  } catch (error) {
    throw error;
  }
}

export const changePasswordService = async (credentials) => {
  try {
    return await changePasswordRepository(credentials);
  } catch (error) {
    throw error;
  }
}

export const getFirebaseTokenService = async (payload) => {
  try {
    return await getFirebaseTokenRepository(payload);
  } catch (error) {
    throw error;
  }
}

// Reenviar correo de confirmación
export const resendVerificationEmailService = async (data) => {
  try {
    return await resendVerificationEmailRepository(data);
  } catch (error) {
    throw error;
  }
};